var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"social-link",attrs:{"target":"_blank","href":_vm.platformURL}},[_c('Sprite',{attrs:{"name":_vm.platformKey}}),(_vm.label)?_c('span',{staticClass:"platform-name"},[_vm._v(_vm._s(_vm.platformValue))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }